import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';

export interface Occupation {
    id: number,
    name: string,
    specify: boolean,
}

export const OTHER_OCCUPATION = {id: 6, name: "Other", specify: true};

@Injectable()
export class OccupationService {

    constructor(private http: Http) {}

    getOccupations(): Observable<Occupation[]> {

        return this.http.get('/api/client/dictionary/occupations').map(result => result.json())
            .map(result => {
                return result.occupations.map(occupation => {
                    return ({
                        id: occupation.id,
                        name: occupation.name,
                        specify: occupation.specify
                    })
                })
            });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/+registration/api/dictionary/occupation.service.ts